import React from "react";

const TONE = {
  success: "bg-emerald-100 text-emerald-800",
  warning: "bg-amber-100 text-amber-800",
  info: "bg-sky-100 text-sky-800",
  neutral: "bg-secondary text-secondary-foreground",
  accent: "bg-accent/15 text-accent",
  danger: "bg-red-100 text-red-800",
  error: "bg-red-100 text-red-800",
};

export default function StatusBadge({ tone = "neutral", children }) {
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${TONE[tone]}`}>
      {children}
    </span>
  );
}
